module.exports = __webpack_public_path__ + "static/media/fnbo.117feb57.png";